import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { PaginationService } from 'src/app/services/pagination.service';
import { AccountDataSourceService } from 'src/app/services/account-data-source.service';
import { MatPaginator } from '@angular/material/paginator';


@Component({
  selector: 'app-analytics-list',
  templateUrl: './analytics-list.component.html',
  styleUrls: ['./analytics-list.component.css']
})

export class AnalyticsListComponent implements OnInit, OnDestroy {

  accountCount: number;
  tableFilters = '';
  dataSource : any;
  // dataSource = new AccountDataSource(this.accountService, this.dataService);
  pageSize = 100;
  isIndependent_sp = true;
  corpid = true;
  displayedColumns;
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  constructor(
    private dataService: AccountDataSourceService,
    private pagination: PaginationService) {
      this.dataService.analytics.subscribe(
        (analyticsInfo:any) => {
          this.displayedColumns = ['dateFor'];
          console.log("Analytics:", analyticsInfo);
          if (analyticsInfo.metricValues && analyticsInfo.metricValues.length > 0 && analyticsInfo.metricValues[0].value) {
            this.displayedColumns.push('value');
          }
          if (analyticsInfo.metricValues && analyticsInfo.metricValues.length > 0 && analyticsInfo.metricValues[0].amount) {
            this.displayedColumns.push('amount');
          }
          console.log(this.displayedColumns);
          this.dataSource = analyticsInfo.metricValues;
          console.log(this.dataSource);
        }
      )
  }
  ngOnDestroy() {
  }

  ngOnInit() {

  }

  setPaginationProperties() {
    this.pagination.resetPage(this.paginator.pageIndex);
  }
}
